import { render } from "./Trailer.vue?vue&type=template&id=a1a6e3b8&scoped=true"
import script from "./Trailer.vue?vue&type=script&lang=js"
export * from "./Trailer.vue?vue&type=script&lang=js"

import "./Trailer.vue?vue&type=style&index=0&id=a1a6e3b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a6e3b8"]])

export default __exports__